import { Button } from '@mui/material'
import styled from 'styled-components'

const ButtonActive = styled(Button)`
    box-shadow: ${props => props.$active ? props.outline : '"inherit"' };
    &:hover {
        box-shadow: ${props => props.$active ? props.outline : "inherit" };
    }
    &.MuiButton-contained.Mui-focusVisible {
        box-shadow: ${props => props.$active ? props.outline : "inherit" };
    }
`;

export default ButtonActive